// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_TEAM_SCORING_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-team-scoring-widget widget=\"$ctrl.widget\"></gb-edit-team-scoring-widget> ";
// Exports
export default code;